import { CONV_STORAGE, onStage, pictureInPicture, room, screenShare, spacesView, Video } from "../../libs/roomnew";

export default class Participants{
    constructor(){
        this.participants={};
        this.inMainScreen=[];
    };
    addParticipant(participant){
        try {
            console.log("Adding new participant",participant);
            if(!this.participants[participant.id] && participant.id){
                this.participants[participant.id]=participant;
                if(!Video.remoteParticipantHasAssignedSpace(participant.id)){
                    spacesView.renderLobbySpaceTiles();
                }
                screenShare.popup.onUserJoined(this.participants[participant.id]);
                console.log("new participant added",this.participants[participant.id]);
                pictureInPicture.updateUsers(this.inSameSpace());
            }else{
                if(!this.participants[participant.id].getSpaceId()){
                    // this.participants[participant.id].removeLobbyThumbnail();
                    // this.participants[participant.id].createLobbyThumbnail();
                    spacesView.renderLobbySpaceTiles();
                }
                console.error("Trying to add participant that already added",this.participants[participant.id]);
            }
            setTimeout(() => {
                Video.efss.inViewPortConversations(false);
            }, 1000);
        } catch (error) {
            console.log("add participant error",error);
        }
    };

    delete(id){
        try {
            if(this.participants[id]){
                this.participants[id].remove().then(()=>{
                    delete this.participants[id];
                    pictureInPicture.updateUsers(this.inSameSpace());
                });

            }
        } catch (error) { console.error("[Kino Error] [Participants]", error); }
    };

    count(withLocal=false){
        return Object.keys(this.participants).length;
    };

    getParticipants(){
        return Object.values(this.participants);
    };

    getLobby(){
        return Object.values(this.participants).filter(p=>!p.getSpaceId());
    };

    //check if a participant is in my space
    isInMySpace(participant_id){
        try {
            if(!CONV_STORAGE.myConversation){
                return false;
            }else{
                if(CONV_STORAGE.conversations[CONV_STORAGE.myConversation]){
                    let pid=CONV_STORAGE.conversations[CONV_STORAGE.myConversation].participants.find(pid=>pid==participant_id);
                    return pid ? true : false;
                }else{
                    return false;
                }
            }
        } catch (error) {
            console.error("Get in my space participant error",error)
            return false;
        }
    };

    //get all participants in my space
    inMySpace(with_me=false){
        try {
            if(!CONV_STORAGE.myConversation){
                return [];
            }else{
                if(CONV_STORAGE.conversations[CONV_STORAGE.myConversation]){
                    return CONV_STORAGE.conversations[CONV_STORAGE.myConversation].participants.filter(pid=>pid!=room.myUserId() || with_me);
                }else{
                    return [];
                }
            }
        } catch (error) {
            console.error("Get in my space participant error",error)
            return [];
        }
    };

    inSameSpace(){
        return this.getParticipants().filter(p=>p.inSameSpaceWithMe()).sort((a,b)=>{
            if(a.local){
                return -1;
            }else{
                return 1;
            }
        });
    };

    me(){
        return Object.values(this.participants).find(p=>p.local);
    };

    get(id){
        if(this.participants[id]){
           return this.participants[id];
        }else{
            return false;
        }
    };
    exists(id){
        return this.participants[id] !== undefined;
    };


    /**
     * add multiple participants in main screen
     */

    addInMainScreen(pids,asFocused=false){
        //first move all to side except pids
        this.addAllInSideScreen(pids);
        //start adding to main screen
        pids.forEach(pid => {
            try {

                if(this.participants[pid]){
                    console.log(`Adding participant ${this.participants[pid].getName()} to Main screen`);
                    if(asFocused && !this.participants[pid].local){
                        this.participants[pid].setAsFocused();
                    }
                    this.participants[pid].moveToMain();
                }
            } catch (error) {
                console.warn(`cann't add participant in main screen ${pid}`,error);
            }
        });
    };

    addAllInSideScreen(except=[]){
        try {
            for (const [pid, participant] of Object.entries(this.participants)) {
                if(!except.includes(pid)){
                    participant.moveToSide();
                }
            }
        } catch (error) { console.error("[Kino Error] [Participants]", error); }
    };

    moveAllToMain(except=[]){
        try {
            for (const [pid, participant] of Object.entries(this.participants)) {
                if(!except.includes(pid)){
                    participant.moveToMain();
                }
            }
        } catch (error) { console.error("[Kino Error] [Participants]", error); }
    }
    moveNonSpaceToMain(){
        console.log("moving non space to main screen");
        for (const [pid, participant] of Object.entries(this.participants)) {
            console.log("Participant space id is",participant.getSpaceId());
            if(!participant.getSpaceId()){
                console.log(participant.getName()+" is not in space moving to main screen");
                participant.moveToMain();
            }
        }
        Video.resizeMainVideos();
    };

    setAllAsFocusedMe(except=[]){
        try {
            console.log("set all as focused me except",except);
            for (const [pid, participant] of Object.entries(this.participants)) {
                if(Video.videos[pid] && !except.includes(pid)){
                    $("#wave-"+pid).remove();
                    Video.videos[pid].viewContainer.addClass('focused-me');
                    Video.videos[pid].focusOnMe = true;
                }
            }
        } catch (error) { console.error("[Kino Error] [Participants]", error); }
    }
    setAllAsUnFocusedMe(){
        try {
            for (const [pid, participant] of Object.entries(this.participants)) {
                if(Video.videos[pid]){
                    $("#wave-"+pid).remove();
                    Video.videos[pid].viewContainer.removeClass('focused-me');
                    Video.videos[pid].focusOnMe = false;
                }
            }
        } catch (error) { console.error("[Kino Error] [Participants]", error); }
    }

    setAsFocused(pids,volume=1){
        try {
            pids.forEach(pid=>{
                let p = this.get(pid);
                if(p && Video.videos[p.id]){
                    $("#wave-"+pid).remove();
                    Video.videos[pid].viewContainer.removeClass('focused-me');
                    Video.videos[pid].focusOnMe = false;
                    Video.focused[pid]=true;
                    p.setVolume(volume,true,false);
                    if(!Video.isTileView){
                        Video.moveVideoToMain(pid);
                    }
                }
            });
            if(!Video.isFocused){
                Video.focusedView();
            }
        } catch (error) { console.error("[Kino Error] [Participants]", error); }
    };

    setAsUnfocused(){
        try {
            for (const [pid, participant] of Object.entries(this.participants)) {
                if(Video.videos[pid]){
                    $("#wave-"+pid).remove();
                    Video.videos[pid].viewContainer.removeClass('focused-me');
                    Video.videos[pid].focusOnMe = false;
                    delete Video.focused[pid];
                }
            }
        } catch (error) { console.error("[Kino Error] [Participants]", error); }
    };
    setAsUnfocusedPids(pids,volume=false,moveVideo=false){
        try {
            pids.forEach(pid=>{
                let p = this.get(pid);
                if(p && Video.videos[p.id]){
                    $("#wave-"+pid).remove();
                    Video.videos[pid].viewContainer.removeClass('focused-me');
                    Video.videos[pid].focusOnMe = false;
                    delete Video.focused[pid];
                    if(volume!==false){
                        p.setVolume(volume,true,false);
                    }
                    if(moveVideo){
                        if(!Video.isTileView && !onStage.myStage.isStageView()){
                            Video.moveVideoToSide(pid);
                        }else if(onStage.myStage.isStageView()){
                            Video.moveVideoToMain(pid);
                        }
                    }
                }
            });
        } catch (error) { console.error("[Kino Error] [Participants]", error); }
    };

    inSameSpaceWith(pid){
        try {
            if(CONV_STORAGE.myConversation){
                return this.isInMySpace(pid);
            }else{
                let pcid=CONV_STORAGE.isOnConversation(pid);
                if(!pcid){
                    if(Object.keys(Video.focused).length > 0 && !Video.focused[pid]){
                        return false;
                    }
                    return true;
                }
                return false;
            }
        } catch (error) {
            return false;
        }
    };

};
